import React from 'react';
import githubIcon from '../../assets/png/icons8-github-32.png';
import instagramIcon from '../../assets/png/icons8-instagram-32.png';
import linkedinIcon from '../../assets/png/icons8-linkedin-32.png';
import SocialIcon from './SocialIcon';

const SocialList = ({ containerClass, iconClass }) => {
  return (
    <div className={`${containerClass}`}>
      <SocialIcon
        href="https://github.com/JorgeCasagrande"
        src={githubIcon}
        alt="GitHub icon"
        iconClass={iconClass}
      />
      <SocialIcon
        href="https://www.linkedin.com/in/jorge-casagrande-35939875/"
        src={linkedinIcon}
        alt="LinkedIn icon"
        iconClass={iconClass}
      />
      <SocialIcon
        href="https://www.instagram.com/negrocasagrande/"
        src={instagramIcon}
        alt="Instagram icon"
        iconClass={iconClass}
      />
    </div>
  );
};

export default SocialList;